<template>
	<div class="flex flex-row justify-content-between align-items-center m-2 bg-grey">
		<div class="flex flex-row align-items-center">
			<PSelectButton
				:allowEmpty="false"
				:options="options"
				@click="save()"
				aria-labelledby="basic"
				v-model="option"
			/>
		</div>
		<!-- <PButton
			label="Save"
			text
		/>-->
	</div>
</template>

<script lang="ts">
	import { defineComponent } from 'vue'
	import Constants from '@/helpers/Constants'
	import PB from '@/brokers/PersistencyBroker'
	import Utils from '@/utils/Utils'
	import EventBus from '@/utils/EventBus'

	export default defineComponent({
		components: {
		},

		data() {
			return {
				before: '',
				option: 'Live',
				currentTheme: 'aura-dark-teal',
				nextTheme: 'aura-light-blue',
				options: [
					'Live',
					'Audit',
				]
			}
		},

		created() {
			const option = PB.get(Constants.LOCAL_STORAGE_IDS.APP_MODE)
			this.option = option ? option : 'Live'
			this.before = this.option

			if (this.option !== 'Live') {
				this.currentTheme = 'aura-dark-teal'
				this.nextTheme = 'aura-light-blue'
			}
		},

		methods: {
			save() {
				if (this.option != this.before) {
					EventBus.emit(Constants.EVENTS.APP_MODE_CHANGED, this.option)
					PB.set(Constants.LOCAL_STORAGE_IDS.APP_MODE, this.option)
					Utils.showSuccessMessage('Settings have been saved succcessfully.')
					this.before = this.option
				}
			}
		}
	})
</script>

<style scoped>
</style>
